import { isNotNil } from "@src/shared/helpers/guards";
import { LinkProps, Path, useLocation } from "react-router";
import { RouteDialogPath } from "../routeDialogs";

export const RouteDialogSearchParams = {
  ARGS: "dialog.args",
  PATH: "dialog.path",
};

type RouteDialogPathArgs = {
  args?: object;
  to?: LinkProps["to"];
};

export function useRouteDialogPath() {
  const location = useLocation();

  function getRouteDialogPath(
    path: RouteDialogPath,
    { args, to }: RouteDialogPathArgs = {},
  ): Partial<Path> {
    const dialogSearch = {
      [RouteDialogSearchParams.ARGS]: args,
      [RouteDialogSearchParams.PATH]: path,
    };

    if (!to) {
      return {
        pathname: location.pathname,
        search: appendSearchParams(location.search, dialogSearch),
      };
    }

    if (typeof to === "string") {
      const url = new URL(to, window.location.origin);

      return {
        pathname: url.pathname,
        search: appendSearchParams(url.search, dialogSearch),
      };
    }

    return {
      ...to,
      search: appendSearchParams(to.search || "", dialogSearch),
    };
  }

  return { getRouteDialogPath };
}

function appendSearchParams(search: string, params: object): string {
  const url = new URL(window.location.origin + search);
  Object.entries(params).forEach(([key, value]) => {
    if (isNotNil(value)) {
      // If the value is an object, we stringify it
      const paramValue =
        typeof value === "object" ? JSON.stringify(value) : value;
      url.searchParams.set(key, String(paramValue));
    }
  });

  return url.search;
}
